import gql from 'graphql-tag';

import { MEDIAREF } from './AssetLibrary';
import { SET_FRAGMENT, UPDATE_LIVE_FRAGMENT } from './EWebinar';
import { REACTION_DETAILS_FIELDS } from './Interactions';
import { ATTENDEE_PROPERTIES_FRAGMENT } from './Property';

export const CONVERSATION_FRAGMENT = gql`
  fragment Conversation on Conversation {
    id
    inEmail
    attendee {
      id
      attendeeFields
      startTime
      firstName
      lastName
      email
      liveSessionType
      lastSegment {
        startTime
        startAtSecs
        endTime
        endAtSecs
        extendedBySecs
        speed
        lastEvent
      }
    }
    isArchived
    lastReadAt
    isAttendeeLive
    sortDate
    hasUnreadMessages
    lastMessage {
      id
      fromAttendee
      content
      timeSent
      type
      subtype
    }
    set {
      id
    }
    isAttendeeLive
  }
  ${SET_FRAGMENT}
  ${ATTENDEE_PROPERTIES_FRAGMENT}
`;

export const CONVERSATION_WITH_PROPERTIES_FRAGMENT = gql`
  fragment ConversationWithAttendeeProperties on Conversation {
    id
    inEmail
    attendee {
      id
      attendeeFields
      startTime
      firstName
      lastName
      email
      liveSessionType
      lastSegment {
        startTime
        startAtSecs
        endTime
        endAtSecs
        extendedBySecs
        speed
        lastEvent
      }
      properties {
        ...AttendeeActionProperties
      }
    }
    isArchived
    lastReadAt
    isAttendeeLive
    sortDate
    hasUnreadMessages
    lastMessage {
      id
      fromAttendee
      content
      timeSent
      type
      subtype
    }
    set {
      id
    }
    isAttendeeLive
  }
  ${SET_FRAGMENT}
  ${ATTENDEE_PROPERTIES_FRAGMENT}
`;

export const CONVERSATIONS_FRAGMENT = gql`
  fragment Conversations on Conversations {
    conversations {
      ...Conversation
    }
    total
    nextCursor
  }
  ${CONVERSATION_FRAGMENT}
`;

export const MESSAGE_FRAGMENT = gql`
  fragment Message on Message {
    id
    uuid
    timeSent
    roomType
    timeInWebinarSecs
    fromAttendee
    sentByEmail
    sendError
    sendRetriable
    user {
      id
      firstName
      lastName
      profileMediaRef {
        ...MediaRef
      }
    }
    content
    type
    subtype
    reaction {
      id
      interactionType
      stringAnswer
      numberAnswer
      arrayAnswer
      detailsFields {
        ...ReactionDetails
      }
    }
    interaction {
      id
      type
      details {
        title
        description
        selectionType
        answers {
          value
          text
          isOther
          isAnswer
        }
      }
    }
  }
  ${MEDIAREF}
  ${REACTION_DETAILS_FIELDS}
`;

export const GET_CONVERSATION = gql`
  query conversation($id: String!) {
    conversation(id: $id) {
      ...ConversationWithAttendeeProperties
      messages {
        ...Message
      }
    }
  }
  ${CONVERSATION_WITH_PROPERTIES_FRAGMENT}
  ${MESSAGE_FRAGMENT}
`;

export const GET_CONVERSATION_FOR_ATTENDEE = gql`
  query conversationForAttendee($attendeeId: String!) {
    conversationForAttendee(attendeeId: $attendeeId) {
      ...Conversation
      messages {
        ...Message
      }
    }
  }
  ${CONVERSATION_FRAGMENT}
  ${MESSAGE_FRAGMENT}
`;

export const GET_CONVERSATIONS = gql`
  query conversations($filters: ConversationFilters!) {
    conversations(filters: $filters) {
      conversations {
        ...Conversation
      }
      total
      nextCursor
    }
  }
  ${CONVERSATIONS_FRAGMENT}
`;

const ARCHIVED_CONVERSATION_FRAGMENT = gql`
  fragment ArchivedConversation on Conversation {
    id
    isArchived
    set {
      id
      ...UpdateLiveFragment
    }
  }
  ${UPDATE_LIVE_FRAGMENT}
`;

export const ARCHIVE_CONVERSATION = gql`
  mutation ArchiveConversation($id: String!) {
    archiveConversation(id: $id) {
      ...ArchivedConversation
    }
  }
  ${ARCHIVED_CONVERSATION_FRAGMENT}
`;

export const SEEN_CONVERSATION = gql`
  mutation seenConversation($id: String!) {
    seenConversation(id: $id) {
      id
      hasUnreadMessages
      set {
        id
        ...UpdateLiveFragment
      }
    }
  }
`;
